import ChecklistReportInterviewComponent, {
  ChecklistReportInterviewComponentProps,
} from './ChecklistReportInterviewComponent';

export default ChecklistReportInterviewComponent;

export type { ChecklistReportInterviewComponentProps };
